export const FETCH_EMPLOYEES = "FETCH_EMPLOYEES";
export const LIST_EMPLOYEES = "LIST_EMPLOYEES";
export const FETCH_EMPLOYEE = "FETCH_EMPLOYEE";
export const SHOW_EMPLOYEE = "SHOW_EMPLOYEE";
export const CREATE_EMPLOYEE = "CREATE_EMPLOYEE";
export const MODIFIED_EMPLOYEE = "MODIFIED_EMPLOYEE";

export const FETCH_ROLES = "FETCH_ROLES";
export const LIST_ROLES = "LIST_ROLES";
export const FETCH_ROLE = "LIST_ROLE";
export const GET_ROLE = "GET_ROLE";
export const CREATE_ROLE = "CREATE_ROLE";
export const UPDATE_ROLE = "UPDATE_ROLE";

export const FETCH_PERMISSIONS = "FETCH_PERMISSIONS";
export const LIST_PERMISSIONS = "LIST_PERMISSIONS";
export const FILTER_PERMISSIONS = "FILTER_PERMISSIONS";

export const FETCH_SETTINGS = "FETCH_SETTINGS";
export const LIST_SETTINGS = "LIST_SETTINGS";
export const MODIFY_SETTINGS = "MODIFY_SETTINGS";

export const FETCH_LOBBIES = "FETCH_LOBBIES";
export const LIST_LOBBIES = "LIST_LOBBIES";
export const FETCH_LOBBY = "FETCH_LOBBY";
export const SHOW_LOBBY = "SHOW_LOBBY";
export const CREATE_LOBBY = "CREATE_LOBBY";
export const UPDATE_LOBBY = "UPDATE_LOBBY";
export const FETCH_LOBBY_TRANSACTION = "FETCH_LOBBY_TRANSACTION";
export const LIST_LOBBY_TRANSACTION = "LIST_LOBBY_TRANSACTION";

export const CREATE_SLIDER = "CREATE_SLIDER";
export const FETCH_SLIDERS = "FETCH_SLIDERS";
export const FETCH_SLIDER = "FETCH_SLIDER";
export const LIST_SLIDERS = "LIST_SLIDERS";
export const SHOW_SLIDER = "SHOW_SLIDER";
export const UPDATE_SLIDER = "UPDATE_SLIDER";
export const DELETE_SLIDER = "DELETE_SLIDER";
